import React from "react";
import { RetailStore } from "tsi-common-react/src/models/location";
import { SyncStoreID } from "tsi-common-react/src/models/nominals";
import { preferredLocationSelector } from "tsi-common-react/src/store/common/selectors";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";

import { defaultLocation } from "../defaults";
import { loadStoreByExternalID } from "../thunks";
import { LocatorSendSingleStore as LocatorSendSingleStoreComponent } from "./LocatorSendSingleStoreContent";

export const LocatorSendSingleStore = (props: {
    storeID: SyncStoreID;
}): React.ReactNode => {
    const location = useAppSelector(preferredLocationSelector);
    const dispatch = useAppDispatch();
    const [store, setStore] = React.useState<RetailStore | null>(null);
    const lastStoreIDRef = React.useRef<SyncStoreID | null>(null);

    React.useEffect(() => {
        if (lastStoreIDRef.current === props.storeID) {
            return;
        }
        lastStoreIDRef.current = props.storeID;
        const effectiveLocation = location || defaultLocation;
        const loadStore = async () => {
            const result = await dispatch(
                loadStoreByExternalID({
                    location: effectiveLocation,
                    storeID: props.storeID,
                }),
            );
            if (result.payload && Array.isArray(result.payload)) {
                setStore(result.payload[0] || null);
            }
        };
        void loadStore();
    }, [location, props.storeID, dispatch]);

    if (!store) {
        return null;
    }
    return <LocatorSendSingleStoreComponent store={store} />;
};
